import React from 'react';
import CenteredPage from '../components/CenteredPage';
import {Title} from '../AppTemplate/Title';
import {Divider, Typography} from '@material-ui/core';
import {AppButton} from '../AppTemplate/Button';

const NotFound = () => (
  <CenteredPage className="page">
    <Title title="404" />
    <Typography variant="h6">
      Stranica nije pronađena ili je još u izradi. Molimo vas da se vratite na početnu stranicu.
    </Typography>
    <Divider />
    <div style={{height: 20}} />
    <AppButton to="/" variant="contained" color="primary" label="Početna stranica" onPress={()=> window.location.href='/'} />
  </CenteredPage>
);

export default NotFound;
